import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { gr } from "../tokens";

// Tinted inner panel for grouped information inside a card (radius 12, padding 16).
export default function GrPanel({ as = "div", children, sx, ...rest }) {
  return (
    <Box
      component={as}
      sx={{
        minWidth: 0,
        background: gr.color.tint,
        borderRadius: gr.radius.tile,
        padding: gr.space[4],
        color: gr.color.ink,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}

GrPanel.propTypes = {
  as: PropTypes.string,
  children: PropTypes.node,
  sx: PropTypes.object,
};
